// extracted by mini-css-extract-plugin
export var active = "_fu-7";
export var blink = "_fu-8";
export var dropDownSelector = "_fu-4";
export var dropDownWrapper = "_fu-3";
export var fakeCursor = "_fu-6";
export var fontSizeButton = "_fu-9";
export var formQuillEditor = "_fu-0";
export var pressed = "_fu-a";
export var qlBlank = "_fu-1";
export var textFormattingToolbar = "_fu-2";
export var textToolbarOption = "_fu-5";